// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const ScoresOut = zod.object({
  "context_fit": zod.int(),
  "evidence": zod.int(),
  "problem_fit": zod.int()
});

export type ScoresOut = zod.input<typeof ScoresOut>;
export type ScoresOutOutput = zod.output<typeof ScoresOut>;
